import _Hash_default from "./_Hash.js";
import _ListCache_default from "./_ListCache.js";
import _Map_default from "./_Map.js";

//#region ../../node_modules/lodash-es/_mapCacheClear.js
/**
* Removes all key-value entries from the map.
*
* @private
* @name clear
* @memberOf MapCache
*/
function mapCacheClear() {
	this.size = 0;
	this.__data__ = {
		"hash": new _Hash_default(),
		"map": new (_Map_default || _ListCache_default)(),
		"string": new _Hash_default()
	};
}
var _mapCacheClear_default = mapCacheClear;

//#endregion
export { _mapCacheClear_default as default };
//# sourceMappingURL=_mapCacheClear.js.map